import TPWebClient, {IGenericResponse} from '@/TPWebClient';
import {IMenuDTO} from '@/TPWebClientInternal/dtos/menu.dto';
import {ReplaySubject, Subject} from 'rxjs';
import {IInternalTicketDTO} from '@/TPWebClientInternal/dtos/internal-ticket.dto';
import {IInternalLocationDTO} from '@/TPWebClientInternal/dtos/internal-location.dto';
import {IUpdateLineItemDTO} from '@/TPWebClientInternal/dtos/update-line-item.dto';
import {IAddLineItemDTO} from '@/TPWebClientInternal/dtos/add-line-item.dto';
import {ICreateItemDTO} from '@/TPWebClientInternal/dtos/create-item.dto';
import {IUpdateItemDTO} from '@/TPWebClientInternal/dtos/update-item.dto';
import {ICreateOptionDTO} from '@/TPWebClientInternal/dtos/create-option.dto';
import {IUpdateOptionDTO} from '@/TPWebClientInternal/dtos/update-option.dto';
import {ICreateChoiceDTO} from '@/TPWebClientInternal/dtos/create-choice.dto';
import {IUpdateChoiceDTO} from '@/TPWebClientInternal/dtos/update-choice.dto';
import {ICreateCategoryDTO} from '@/TPWebClientInternal/dtos/create-category.dto';
import {IUpdateCategoryDTO} from '@/TPWebClientInternal/dtos/update-category.dto';
import {ICreateMenuDTO} from '@/TPWebClientInternal/dtos/create-menu.dto';
import {IUpdateMenuDTO} from '@/TPWebClientInternal/dtos/update-menu.dto';





export default class TPWebClientInternal extends TPWebClient<IInternalLocationDTO, IInternalTicketDTO> {
	async fetchMenu(menuId = 'live'): Promise<IGenericResponse<{menu: IMenuDTO}>> {
		return this.axios({
			method: 'GET',
			url: 'menus/' + menuId,
		});
	}

	async getMenus() {
		return await this.axios({
			method: 'GET',
			url: 'menus',
		}) as IGenericResponse<{menus: {[key: string]: IMenuDTO}}>;
	}

	async addLineItem(ticketId: string, menuId: string, items: IAddLineItemDTO[]) {
		return this.axios({
			method: 'POST',
			data: {
				menuId: menuId,
				items: items
			},
			url: '/tickets/' + ticketId + '/lineitems',
		});
	}

	async updateLineItem(ticketId: string, item: IUpdateLineItemDTO) {
		return this.axios({
			method: 'POST',
			data: item,
			url: '/tickets/' + ticketId + '/lineitems/' + item.lineItemId + '/update',
		});
	}

	async deleteLineItem(ticketId: string, lineItemId: number) {
		return this.axios({
			method: 'POST',
			url: '/tickets/' + ticketId + '/lineitems/' + lineItemId + '/delete',
		});
	}

	locationUpdated() {
		return this.locationReplaySubject as ReplaySubject<IInternalLocationDTO>;
	}

	ticketsUpdated() {
		return super.ticketsUpdated() as ReplaySubject<IInternalTicketDTO[]>;
	}
	ticketUpdated() {
		return super.ticketUpdated() as Subject<IInternalTicketDTO>;
	}


	async createItem(body: ICreateItemDTO) {
		return this.axios({
			method: 'POST',
			data: body,
			url: '/items',
		});
	}

	async addItemToMenu(menuId: string, categoryId: number, itemId: string) {
		return this.axios({
			method: 'POST',
			data: {
				itemId: itemId,
				subCategoryId: 0
			},
			url: '/menus/' + menuId + '/categories/' + categoryId + '/items',
		});
	}

	async updateItem(body: IUpdateItemDTO) {
		return this.axios({
			method: 'POST',
			data: body,
			url: '/items/' + body.itemId,
		});
	}

	async removeItemFromMenu(menuId: string, categoryId: number, itemId: string) {
		return this.axios({
			method: 'POST',
			data: {
				// categoryId: categoryId
			},
			url: '/menus/' + menuId + '/categories/' + categoryId + '/items/' + itemId + '/delete',
		});
	}

	async createOption(body: ICreateOptionDTO) {
		return this.axios({
			method: 'POST',
			data: body,
			url: '/options',
		});
	}

	async addOptionToItem(itemId: string, optionId: string) {
		return this.axios({
			method: 'POST',
			data: {
				optionId: optionId
			},
			url: '/items/' + itemId + '/options',
		});
	}

	async updateOption(body: IUpdateOptionDTO) {
		return this.axios({
			method: 'POST',
			data: body,
			url: '/options/' + body.optionId,
		});
	}

	async removeOptionFromItem(itemId: string, optionId: string) {
		return this.axios({
			method: 'POST',
			data: {
				// categoryId: categoryId
			},
			url: '/items/' + itemId + '/options/' + optionId + '/delete',
		});
	}

	async createChoice(optionId: string, body: ICreateChoiceDTO) {
		return this.axios({
			method: 'POST',
			data: body,
			url: '/options/' + optionId + '/choices',
		});
	}

	async updateChoice(optionId: string, body: IUpdateChoiceDTO) {
		return this.axios({
			method: 'POST',
			data: body,
			url: '/options/' + optionId + '/choices/' + body.choiceId,
		});
	}

	async removeChoiceFromOption(optionId: string, choiceId: string) {
		return this.axios({
			method: 'POST',
			data: {
				// categoryId: categoryId
			},
			url: '/options/' + optionId + '/choices/' + choiceId + '/delete',
		});
	}

	async getItems() {
		return this.axios({
			method: 'GET',
			url: '/items',
		});
	}

	async getOptions() {
		return this.axios({
			method: 'GET',
			url: '/options',
		});
	}

	async createCategory(menuId: string, body: ICreateCategoryDTO) {
		return this.axios({
			method: 'POST',
			data: body,
			url: '/menus/' + menuId + '/categories',
		});
	}

	async updateCategory(menuId: string, body: IUpdateCategoryDTO) {
		return this.axios({
			method: 'POST',
			data: body,
			url: '/menus/' + menuId + '/categories/' + body.categoryId,
		});
	}

	async deleteCategory(menuId: string, categoryId: string) {
		return this.axios({
			method: 'POST',
			url: '/menus/' + menuId + '/categories/' + categoryId + '/delete',
		});
	}

	async createMenu(body: ICreateMenuDTO) {
		return this.axios({
			method: 'POST',
			data: body,
			url: '/menus'
		});
	}

	async updateMenu(body: IUpdateMenuDTO) {
		return this.axios({
			method: 'POST',
			data: body,
			url: '/menus/' + body.menuId
		});
	}

	async deleteMenu(menuId: string) {
		return this.axios({
			method: 'POST',
			url: '/menus/' + menuId + '/delete'
		});
	}
}
